module.exports = __webpack_public_path__ + "img/end.b7d45108.png";